import React from 'react';
import './loader.css' // Path to your CSS file

class CustomLoading extends React.Component {
    render() {
        return (
            <div>
                {/* Your other component content */}
                <div className="loader">
                    <img src='/img/logo-192.gif' width={200} height={200} />
                </div>
            </div>
        );
    }
}

export default CustomLoading